module.exports = __webpack_public_path__ + "media/Podcast_Instruccional_CF02_33110059_Trabajo en equipo.3c13400e.wav";